// extracted by mini-css-extract-plugin
module.exports = {"mainMobile":"PublicLayoutMobile-module__mainMobile__7APqa","container":"PublicLayoutMobile-module__container__zi+tU"};